import api from "@/lib/api";

export async function telechargerDossierInspection() {
  const r = await api.get("/conformite/dossier-inspection", { responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r.data);
  a.download = `dossier-inspection-oscop-ge-${new Date().toISOString().slice(0, 10)}.zip`;
  a.click();
  URL.revokeObjectURL(a.href);
}
